// Datetime helpers to ensure consistent parsing/formatting across timezones
// - Parse API timestamps (ISO 8601) which should include timezone (UTC)
// - If timestamp has no timezone offset, treat it as UTC (append Z) so we preserve the instant

export function parseApiDate(value: string | null | undefined): Date | null {
  if (!value) return null;

  // If the string lacks an explicit timezone (no trailing Z or +/-HH:MM), treat as UTC
  const hasTz = /(?:Z|[+-]\d{2}:\d{2})$/i.test(value);
  const looksIso = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d{1,9})?)?$/.test(value);
  const normalized = !hasTz && looksIso ? `${value}Z` : value;

  const d = new Date(normalized);
  return isNaN(d.getTime()) ? null : d;
}

export function formatLocalDateTime(value: string | Date | null | undefined): string {
  const d = value instanceof Date ? value : parseApiDate(value as string);
  if (!d) return 'N/A';
  try {
    return d.toLocaleString('en-US', {
      month: 'numeric',
      day: '2-digit',
      year: '2-digit',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  } catch {
    return 'N/A';
  }
}

export function formatLocalTime(value: string | Date | null | undefined): string {
  const d = value instanceof Date ? value : parseApiDate(value as string);
  if (!d) return 'N/A';
  try {
    return d.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  } catch {
    return 'N/A';
  }
}

export function formatSimpleDateTime(value: string | Date | null | undefined): string {
  const d = value instanceof Date ? value : parseApiDate(value as string);
  if (!d) return 'N/A';
  try {
    return d.toLocaleTimeString('en-US', {
      month: 'numeric',
      day: '2-digit',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  } catch {
    return 'N/A';
  }
}
